<template>
  <b-overlay :show="show">
    <b-row>
        <b-col sm="12" md="4" class="my-1">
            <span style="font-size:16px"> <b> {{ $t('art_id') }} :</b> {{ Data.art_id }} </span>
        </b-col>
        <b-col sm="12" md="4" class="my-1">
            <span style="font-size:16px"> <b> {{ $t('ondate') }} :</b> {{ Data.dateini }} - {{ Data.date_end }}  </span>
        </b-col>
        <!-- <b-col sm="12" md="12" class="my-1">
            <span style="font-size:16px"> <b> {{ $t('item_group_name') }} :</b> {{ Data.item_group_name }} </span>
        </b-col>
        <b-col sm="12" md="12" class="my-1">
            <span style="font-size:16px"> <b> {{ $t('item_name') }} :</b> {{ Data.item_name }} </span>
        </b-col> -->
    </b-row>
    <b-row class="mt-4">
        <b-col>
            <b-card>
                <h4 class="text-center"> {{ $t('buyer') }} </h4>
                <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('oblast') }}: </b>  <span class="ml-2"> {{ Data.buyerregion }} </span> </span><br />
                <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('region') }}: </b>  <span class="ml-2"> {{ Data.buyerrayon }} </span> </span><br />
                <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('name') }}: </b>  <span class="ml-2"> {{ Data.buyername }} ({{ Data.buyerinn }}) </span> </span><br />
                <!-- <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('inn') }}: </b>  <span class="ml-2"> {{ Data.buyerinn }} </span> </span><br /> -->
                <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('address') }}: </b>  <span class="ml-2"> {{ Data.buyeraddress }} </span> </span><br />
                <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('account') }}: </b>  <span class="ml-2"> {{ Data.buyeraccount }} </span> </span>
            </b-card>
        </b-col>
        <b-col>
            <b-card>
                <h4 class="text-center"> {{ $t('seller') }} </h4>
                <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('oblast') }}: </b>  <span class="ml-2"> {{ Data.sellerregion }} </span> </span><br />
                <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('region') }}: </b>  <span class="ml-2"> {{ Data.sellerrayon }} </span> </span><br />
                <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('name') }}: </b>  <span class="ml-2"> {{ Data.sellername }} ({{ Data.sellerinn }}) </span> </span><br />
                <!-- <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('inn') }}: </b>  <span class="ml-2"> {{ Data.sellerinn }} </span> </span><br /> -->
                <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('address') }}: </b>  <span class="ml-2"> {{ Data.selleraddress }} </span> </span><br />
                <span style="font-size:14px"> <b style="margin-right:10px"> {{ $t('account') }}: </b>  <span class="ml-2"> {{ Data.selleraccount }} </span> </span>
            </b-card>
        </b-col>
    </b-row>
    <b-row class="mt-3">
        <b-col>
            <b-tabs
        pills
      >
      <b-tab active>
          <template v-slot:title>
            <span> {{ $t('products') }} </span>
          </template>
          <b-card-text class="mt-3">
            <b-table
                :fields="ProductFields"
                :items="Data.lot_Info_Product_Table"
                bordered
                head-row-variant="info"
            >
             <template #cell(quantity)="{item}">
                    {{
                    $options.filters.currency(item.quantity, {
                    symbol: "",
                    fractionCount: 0,
                    })
                }}
                </template>
                <template #cell(one_price)="{item}">
                    {{
                    $options.filters.currency(item.one_price, {
                    symbol: "",
                    fractionCount: 0,
                    })
                }}
                </template>
                <template #cell(all_price)="{item}">
                    {{
                    $options.filters.currency(item.all_price, {
                    symbol: "",
                    fractionCount: 0,
                    })
                }}
                </template>
            </b-table>
          </b-card-text>
        </b-tab>
        <b-tab >
          <template v-slot:title>
            <span> {{ $t('bids') }} </span>
          </template>
          <b-card-text class="mt-3">
            <b-table
                :fields="BidFields"
                :items="Data.lot_Info_Bid_Table"
                bordered
                head-row-variant="info"
            >
                <template #cell(bid_cost)="{item}">
                    {{
                    $options.filters.currency(item.bid_cost, {
                    symbol: "",
                    fractionCount: 0,
                    })
                }}
                </template>
            </b-table>
          </b-card-text>
        </b-tab>
        
      </b-tabs>
        </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import UzexService from "@/services/others/uzex.service";
export default {
    props :{
        id : {
            type : String,
            default : ""
        }
    },
    data(){
        return{
            show : true,
            BidFields : [
                { key : 'rownumber', label : '№' },
                { key : 'provider_name', label : this.$t("name") },
                { key : 'provider_tin', label : this.$t("inn") },
                { key : 'bid_cost', label : this.$t("totalcost"),class:'text-end' }
            ],
            ProductFields : [
                { key : 'rownumber', label : '№' },
                { key : 'tnvd_code', label : this.$t("productcategory") },
                { key : 'expend_id', label : this.$t("itemofexpense") },
                { key : 'item_name', label : this.$t("productgroup") },
                { key : 'p_product_name', label : this.$t("product") },
                { key : 'quantity', label : this.$t("quantity") ,class:'text-end'},
                { key : 'one_price', label : this.$t("one_price"),class:'text-end' },
                { key : 'all_price', label : this.$t("all_price"),class:'text-end' },
            ],
            Data:{}
        }
    },
    created(){
        this.show = true
        UzexService.GetLotInfo(this.id).then(res => {
            this.show = false
            this.Data = res.data.result
        }).catch(error => {
            this.show = false
        })
    }
}
</script>

<style>

</style>